import { ApiFetchResponse } from '@terminal/utils/api-fetch/apiFetch';
import { create } from '@terminal/utils/store/createStore';

import { getSettings, updateSettings } from './chat-settings-services';

const PERSONALIZATION_LINK_KEY = 'personalization_link_visible';
const MS_ONE_DAY = 24 * 60 * 60 * 1000;

const setPersonalizationBarExpiry = (value: boolean) => {
  const item = {
    value,
    expiry: Date.now() + MS_ONE_DAY,
  };
  localStorage.setItem(PERSONALIZATION_LINK_KEY, JSON.stringify(item));
};

const getPersonalizationBarExpiry = (): boolean => {
  const itemStr = localStorage.getItem(PERSONALIZATION_LINK_KEY);

  if (!itemStr) {
    return true;
  }

  const item = JSON.parse(itemStr);
  const now = Date.now();

  if (now > item.expiry) {
    localStorage.removeItem(PERSONALIZATION_LINK_KEY);
    return true;
  }

  return item.value;
};

type ChatSettingsStore = {
  displayPersonalizationLink: boolean;
  displayPersonalizationDrawer: boolean;
  preferenceFormat?: string;
  setPreferenceFormat: (prompt: string) => Promise<ApiFetchResponse<unknown>>;
  getPreferenceFormat: () => Promise<void>;
  setDisplayPersonalizationDrawer: (display: boolean) => void;
  hidePersonalizationLinkForDay: () => void;
};

export const useChatSettings = create<ChatSettingsStore>(set => ({
  displayPersonalizationLink: true,
  displayPersonalizationDrawer: false,
  preferenceFormat: undefined,

  setDisplayPersonalizationDrawer: (display: boolean) => {
    set({ displayPersonalizationDrawer: display });
  },

  hidePersonalizationLinkForDay: () => {
    setPersonalizationBarExpiry(false);
    set({ displayPersonalizationLink: false });
  },

  getPreferenceFormat: async () => {
    const response = await getSettings();
    const shouldShow = getPersonalizationBarExpiry();
    const prompt = response.data?.prompt;

    set({
      preferenceFormat: prompt,
      displayPersonalizationLink: prompt ? false : shouldShow,
    });
  },
  setPreferenceFormat: async (prompt: string) => {
    const response = await updateSettings(prompt);

    if (!response.error) {
      set({
        preferenceFormat: prompt,
        displayPersonalizationDrawer: false,
        displayPersonalizationLink: false,
      });
    }

    return response;
  },
}));
